import { CryptoHelper } from 'utils/CryptoHelper';
import uuidv4 from 'uuid/dist/v4';

import { BoundCsrfTokenSelectrors } from 'reactApp/modules/CsrfTokenModule/CsrfTokenModule.selectors';
import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule/CurrentUserModule.selectors';
import xPageId from 'xPageId';
import xTabId from 'xTabId';

function reloadIfProjectOrUserBlocked(
    response?: { message: string; error: string },
    url?: string,
) {
    const isAuthorised = url !== '/api/v1/auth/signin';
    const isDisabled =
        response?.error === 'ACCESS_DENIED' &&
        ['Project disabled', 'User disabled'].includes(response.message);

    if (isAuthorised && isDisabled) {
        window.location.reload();
    }
}

function getCommonRequestHeaders(): Record<string, string> {
    const token = BoundCsrfTokenSelectrors.getToken();

    return {
        [HEADER_KEYS.X_CSRF_TOKEN]: token,

        [HEADER_KEYS.CACHE_CONTROL]: 'no-cache',

        [HEADER_KEYS.X_REQ_ID_HEADER]: CryptoHelper.getBase58Id(8),
        [HEADER_KEYS.X_MCS_REQUEST_ID]: uuidv4().replace(/-/g, ''),
        [HEADER_KEYS.X_EMAIL]: BoundCurrentUserSelectors.getEmail(),
        [HEADER_KEYS.X_TAB_ID]: xTabId,
        [HEADER_KEYS.X_PAGE_ID]: xPageId,
    };
}

function headersToObject(headers: Response['headers']) {
    const obj = {};
    headers.forEach((value, key) => {
        obj[key] = value;
    });
    return obj;
}

const HEADER_KEYS = {
    X_CSRF_TOKEN: 'x-csrf-token',

    CACHE_CONTROL: 'Cache-Control',

    X_REQ_ID_HEADER: 'x-req-id',
    X_MCS_REQUEST_ID: 'X-MCS-Request-Id',
    X_EMAIL: 'x-email',
    X_TAB_ID: 'x-tab-id',
    X_PAGE_ID: 'x-page-id',
};

export const ApiUtils = {
    reloadIfProjectOrUserBlocked,
    getCommonRequestHeaders,
    headersToObject,
    HEADER_KEYS,
};
